export default {
  props: ['id'],
  data() {
    return {
      dialog: {
        active: false,
        content: '',
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    course() {
      return this.$store.state.courses.course;
    },
    test() {
      return this.course.tests && this.course.tests[0] ? this.course.tests[0] : null;
    },
    videoFrame() {
      const raw = this.course && this.course.video_1_frame ? String(this.course.video_1_frame).trim() : '';
      if (!raw || /<\w/.test(raw)) return raw;
      const rutube = raw.match(/rutube\.ru\/(?:video|play\/embed)\/([a-z0-9]+)/i);
      if (rutube) {
        return `<iframe src="https://rutube.ru/play/embed/${rutube[1]}" frameborder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowfullscreen></iframe>`;
      }
      const youtube = raw.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([\w-]+)/i);
      if (youtube) {
        return `<iframe src="https://www.youtube.com/embed/${youtube[1]}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
      }
      const vkExt = raw.match(/(?:vk\.com|vkvideo\.ru|vk\.ru)\/video_ext\.php\?([^\s"<>'`]+)/i);
      if (vkExt) {
        return `<iframe src="https://vk.com/video_ext.php?${vkExt[1]}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
      }
      const vkVideo = raw.match(/(?:vk\.com|vkvideo\.ru|vk\.ru)\/video(-?\d+)_(\d+)/i);
      if (vkVideo) {
        return `<iframe src="https://vk.com/video_ext.php?oid=${vkVideo[1]}&id=${vkVideo[2]}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
      }
      return raw;
    },
  },
  methods: {
    startTest() {
      this.$router.push(`/test/${this.test.id}`);
    },
    showPDF(url) {
      this.dialog.active = true;
      this.dialog.content = `<iframe src="${url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
  },
  mounted() {
    if (this.user && this.user.profile_id) {
      this.$store.dispatch('courses/GetCourse', {
        course_id: this.id,
        profile_id: this.user.profile_id,
      });
    }
  },
};
